// extracted by mini-css-extract-plugin
export var button = "_kt-2";
export var card = "_kt-0";
export var closeButtonContainer = "_kt-3";
export var iconContainer = "_kt-1";